export const BILLS_SUCCESS = 'BILLS_SUCCESS';
export const ACCOUNTS_LOADING = 'ACCOUNTS_LOADING';
export const SET_ROLE_PERMISSIONS_LOADING = 'SET_ROLE_PERMISSIONS_LOADING';
export const SET_ROLE_PERMISSIONS_STATUSES = 'SET_ROLE_PERMISSIONS_STATUSES';
export const SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS = 'SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS';
export const SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS = 'SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS';
export const SET_FILTERS_CONFIGURATION = 'SET_FILTERS_CONFIGURATION';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const SET_SELECTED_ACCOUNTS = 'SET_SELECTED_ACCOUNTS';
export const SET_ACCOUNT_CHARGES = 'SET_ACCOUNT_CHARGES';
export const SET_ACCOUNT_CHARGES_LOADING = 'SET_ACCOUNT_CHARGES_LOADING';
export const SET_ALL_SUPPORT_DOCUMENT_FILES = 'SET_ALL_SUPPORT_DOCUMENT_FILES';
export const SET_SUPPORT_FILES_LOADING = 'SET_SUPPORT_FILES_LOADING';
export const SET_SUPPORT_FILES_BY_CHARGE = 'SET_SUPPORT_FILES_BY_CHARGE';
export const SET_SUPPORT_FILES_BY_ACCOUNT = 'SET_SUPPORT_FILES_BY_ACCOUNT';
export const SET_SELECTED_CHARGE = 'SET_SELECTED_CHARGE';
export const SET_COMMENTS_ACCOUNT = 'SET_COMMENTS_ACCOUNT';
export const SET_LOADING_RESTRICTED_EVENTS = 'SET_LOADING_RESTRICTED_EVENTS';
export const SET_PAYERS = 'SET_PAYERS';
export const SET_AGREMENTS = 'SET_AGREMENTS';
export const SET_AGRREMENTS_LOADING = 'SET_AGRREMENTS_LOADING';
export const SET_SELECTED_AGREEMENT = 'SET_SELECTED_AGREEMENT';
export const SET_AGREEMENT_CONFIGURATION = 'SET_AGREEMENT_CONFIGURATION';
export const SET_SELECTED_AUDIT_RULE = 'SET_SELECTED_AUDIT_RULE';
export const SET_HEALTHCARE_PLANS = 'SET_HEALTHCARE_PLANS';
export const SET_SERVICE_SUPPORT_DOCUMENTS_LOADING = 'SET_AGREEMENT_SERVICE_SUPPORT_DOCUMENTS_LOADING';
export const SET_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT = 'SET_AGREEMENT_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT';
export const SET_SERVICE_SUPPORT_DOCUMENTS_CHARGE = 'SET_AGREEMENT_SERVICE_SUPPORT_DOCUMENTS_CHARGE';
export const SET_SUPPORT_FILE_TYPES = 'SET_SUPPORT_FILE_TYPES';
export const SET_AGREEMENT_PRODUCTS_LOADING = 'SET_AGREEMENT_PRODUCTS_LOADING';
export const SET_AGREEMENT_PRODUCTS = 'SET_AGREEMENT_PRODUCTS';
export const SET_DISPLAY_DIALOG_COMMENT = 'SET_DISPLAY_DIALOG_COMMENT';
export const SET_COMMENT_CONTROL = 'SET_COMMENT_CONTROL';
export const SET_PAYERS_AVAILABLE = 'SET_PAYERS_AVAILABLE';
export const SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT = 'SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT';
export const SET_ROLE_RCM_USER  = 'SET_ROLE_RCM_USER';
export const SET_PROVIDER_SERVICE_TYPES = 'SET_PROVIDER_SERVICE_TYPES';
export const SET_PROVIDER_EXECUTOR_SERVICES = 'SET_PROVIDER_EXECUTOR_SERVICES';
export const SET_PROVIDER_AGREEMENT_PLAN_TYPES = 'SET_PROVIDER_AGREEMENT_PLAN_TYPES';
export const SET_PROVIDER_INVOICE_SOURCES = 'SET_PROVIDER_INVOICE_SOURCES';
export const SET_PROVIDER_AGREEMENTS = 'SET_PROVIDER_AGREEMENTS';
export const SET_PROVIDER_SUPPORT_DOCUMENTS = 'SET_PROVIDER_SUPPORT_DOCUMENTS';
export const SET_ACCOUNT_LIST_SORT = 'SET_ACCOUNT_LIST_SORT';
export const SET_AGREEMENT_FILTERS = 'SET_AGREEMENT_FILTERS';
export const SET_PRE_SETTLEMENTS = 'SET_PRE_SETTLEMENTS';
export const SET_PRE_SETTLEMENTS_FILTER = 'SET_PRE_SETTLEMENTS_FILTER';
export const SET_PRE_SETTLEMENTS_DETAIL = 'SET_PRE_SETTLEMENTS_DETAIL';
export const SET_ACCOUNTS_SEARCH_VALUE = 'SET_ACCOUNTS_SEARCH_VALUE';
export const SET_ACCOUNT_CHARGES_FILTER = 'SET_ACCOUNT_CHARGES_FILTER';
export const SET_IS_MULTI_PATIENT_ACCOUNT = 'SET_IS_MULTI_PATIENT_ACCOUNT';
export const SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT = 'SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT';
export const SET_SUPPORT_DOCUMENTS_LOADING = 'SET_SUPPORT_DOCUMENTS_LOADING';
export const SET_SUPPORT_DOCUMENTS = 'SET_SUPPORT_DOCUMENTS';
export const SET_SUPPORT_FORMAT_FILE_FIELDS = 'SET_SUPPORT_FORMAT_FILE_FIELDS';
export const SET_SELECTED_PACKAGE_GROUP = 'SET_SELECTED_PACKAGE_GROUP';
export const SET_PROVIDER_PRODUCTS = 'SET_PROVIDER_PRODUCTS';
export const SET_PROVIDER_PRODUCTS_SEARCH_VALUE = 'SET_PROVIDER_PRODUCTS_SEARCH_VALUE';
export const SET_PROVIDER_PRODUCTS_LOADING = 'SET_PROVIDER_PRODUCTS_LOADING';
export const SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG = 'SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG';
export const SET_SELECTED_PROVIDER_PRODUCT = 'SET_SELECTED_PROVIDER_PRODUCT';
export const SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION = 'SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION';
export const SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED = 'SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED';
export const SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION = 'SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION';
export const SET_UPLOADED_AGREEMENT_MATRIX = 'SET_UPLOADED_AGREEMENT_MATRIX';
export const SET_UPLOADED_AGREEMENT_MATRIX_LOADING = 'SET_UPLOADED_AGREEMENT_MATRIX_LOADING';
export const SET_UPLOAD_AGREEMENT_MATRIX_RESULT = 'SET_UPLOAD_AGREEMENT_MATRIX_RESULT';
export const SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING = 'SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING';
export const SET_USERS = 'SET_USERS';
export const REASSIGNED_BILLS_SUCCESS = 'REASSIGNED_BILLS_SUCCESS';
export const REASSIGNED_ACCOUNTS_LOADING = 'REASSIGNED_ACCOUNTS_LOADING';
